(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-registration"]) return;
  try {
    
  if (!customElements.get('toy-event-registration')) {
    customElements.define('toy-event-registration', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.messages = JSON.parse(this.querySelector('[data-event-messages]').textContent);
        this.account = this.querySelector('[data-event-account]');
        this.newPlayer = this.querySelector('[data-event-new]');
        this.syncAccount = () => {
          if (!this.account) return;
          const needsHelp = Boolean(this.newPlayer?.checked);
          this.account.disabled = needsHelp;
          this.account.required = this.account.dataset.required === 'true' && !needsHelp;
          this.account.setCustomValidity('');
        };
        this.newPlayer?.addEventListener('change', this.syncAccount);
        this.syncAccount();
        this.form.addEventListener('input', event => {
          if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
        });
        this.form.addEventListener('submit', event => {
          for (const input of this.querySelectorAll('[data-event-name]')) {
            input.value = input.value.trim();
            input.setCustomValidity(input.value ? '' : this.messages.name);
          }
          const year = this.querySelector('[data-event-year]');
          if (year) {
            const value = Number(year.value);
            year.setCustomValidity(Number.isInteger(value) && value >= 1900 && value <= Number(year.dataset.currentYear) ? '' : this.messages.year);
          }
          if (this.account && !this.account.disabled) {
            this.account.value = this.account.value.trim();
            const value = this.account.value;
            const numericIdValid = this.account.dataset.game !== 'pokemon' || !value || /^[0-9]+$/.test(value);
            this.account.setCustomValidity(numericIdValid ? '' : this.messages.account);
          }
          if (!this.form.reportValidity()) {
            event.preventDefault();
            return;
          }
          if (this.submitting) {
            event.preventDefault();
            return;
          }
          this.submitting = true;
          this.form.querySelector('[type="submit"]').disabled = true;
        });
        window.addEventListener('pageshow', () => {
          if (!this.submitting) return;
          this.submitting = false;
          this.form.querySelector('[type="submit"]').disabled = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
